import { Component } from '@angular/core';

@Component({
  selector: 'app-caps-dialog',
  templateUrl: './caps-dialog.component.html',
  styleUrls: ['./caps-dialog.component.scss']
})
export class CapsDialogComponent {
  constructor() { }
}